import type { StyleRules } from '@material-ui/core/styles';
import { withStyles } from '@material-ui/core/styles';

export default withStyles((theme) => {
  const styles: StyleRules = {
    font: {
      color: '#596375',
      fontSize: 15,
      fontWeight: 400,
    },
    domainInput: {
      width: '100%',
    },
    centerFaq: {
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
    },
    expand: {
      color: theme.palette.primary.main,
      fontWeight: 500,
      fontSize: 16,
    },
  };

  return styles;
});
